import { rankingItems } from '@/mocks/homeMocks';

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-500',
  down: 'ri-arrow-down-line text-foreground-400',
  stable: 'ri-subtract-line text-foreground-400',
};

const rankColors: Record<number, string> = {
  1: 'bg-primary-500 text-white',
  2: 'bg-accent-500 text-white',
  3: 'bg-secondary-500 text-white',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2 scroll-mt-20">
            热门排行
          </h2>
          <p className="text-sm text-foreground-600 mb-6">
            根据阅读热度和读者互动综合排序的漫画榜单
          </p>
          <div className="space-y-3">
            {rankingItems.map((item) => (
              <a
                key={item.id}
                href="#ranking"
                className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-background-50 rounded-lg border border-background-200/70 cursor-pointer hover:border-primary-300 transition-all"
              >
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-sm shrink-0 ${
                    rankColors[item.rank] || 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.rank}
                </div>
                <div className="w-16 h-12 md:w-20 md:h-14 rounded overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base text-foreground-950 truncate">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500">{item.author}</p>
                </div>
                <span className="px-2 py-0.5 bg-secondary-100 text-secondary-800 text-xs rounded whitespace-nowrap shrink-0 hidden sm:inline-block">
                  {item.category}
                </span>
                <div className="flex items-center gap-1 shrink-0">
                  <i className={`text-sm ${trendIcons[item.trend] || trendIcons.stable}`}></i>
                  <span className="text-sm text-foreground-800 whitespace-nowrap">{item.heat}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}